import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/student-pre-interviews/StudentPreInterviewsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { StudentPreInterviewEditForm } from "./StudentPreInterviewEditForm";
import { InterviewsPage } from "./interviews/InterviewsPage";

export function StudentPreInterviewEdit({
  history,
  match: {
    params: { id }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, studentPreInterview } = useSelector(
    (state) => ({
      actionsLoading: state.studentPreInterviews.actionsLoading,
      isSuccess: state.studentPreInterviews.isSuccess,
      type: state.studentPreInterviews.type,
      studentPreInterview: state.studentPreInterviews.studentPreInterview
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getStudentPreInterview(id));
    return () => dispatch(actions.cleanStudentPreInterviewState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Ön Kayıt ve Görüşme";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  /** Belli Bir Ön Kayıt ve Görüşmeyi Kaydeder */
  const saveStudentPreInterview = (values) => {
    dispatch(actions.saveStudentPreInterview(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/on-kayit-ve-gorusmeler"), 2500);
  };

  const btnRef = useRef();  
  const saveStudentPreInterviewClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <>
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title={title} />
        <CardBody>
          <div className="mt-5">
            <StudentPreInterviewEditForm
              id={id}
              btnRef={btnRef}
              studentPreInterview={studentPreInterview}
              saveStudentPreInterview={saveStudentPreInterview}
            />
          </div>
        </CardBody>
        <CardFooter>
          <div className="offset-sm-2">          
            <button
              type="submit"
              className="btn btn-primary"
              onClick={saveStudentPreInterviewClick}
            >
              Kaydet
            </button>
          </div>
        </CardFooter>
      </Card>
      {
        id &&
        <InterviewsPage
          preInterviewId={id}        
        />
      }
    </>
  );
}